module.exports = __webpack_public_path__ + "media/images/custom-email-e76b60347171a4e030f0b622db9dbc51.svg";